import React from "react";

function Skill() {
    return (
        <div>
            <h1 className="text-gray-800 font-bold text-2xl my-6 pl-6 md:pl-0" data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="100">Tech Stack</h1>
            <div className="text-white bg-blue-500 text-center p-2" id="skills">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 my-10">
                    <div data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="200">
                        <img
                            class="mx-auto my-2 bg-white rounded p-2 shadow"
                            src="https://img.icons8.com/color/96/000000/html-5--v1.png"
                            alt="html"
                        />
                        <h3 class="text-white ">HTML</h3>
                    </div>
                    <div data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="400">
                        <img
                            class="mx-auto my-2 bg-white rounded p-2 shadow"
                            src="https://img.icons8.com/color/96/000000/css3.png"
                            alt="css"
                        />
                        <h3 class="text-white ">CSS</h3>
                    </div>
                    <div data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="600">
                        <img
                            class="mx-auto my-2 bg-white rounded p-2 shadow"
                            src="https://img.icons8.com/color/96/000000/javascript--v1.png"
                            alt="javascript"
                        />
                        <h3 class="text-white ">Javascript</h3>
                    </div>
                    <div data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="800">
                        <img
                            class="mx-auto my-2 bg-white rounded p-2 shadow"
                            src="https://img.icons8.com/color/96/null/tailwind_css.png"
                            alt="tailwind" />
                        <h3 class="text-white ">Tailwind</h3>
                    </div>
                    <div data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="1000">
                        <img
                            class="mx-auto my-2 bg-white rounded p-2 shadow"
                            src="https://img.icons8.com/color/96/null/react-native.png"
                            alt="react" />
                        <h3 class="text-white ">React.js</h3>
                    </div>
                    <div data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="1200">
                        <img
                            class="mx-auto my-2 bg-white rounded p-2 shadow"
                            src="https://img.icons8.com/color/96/null/express-js.png"
                            alt="express" />
                        <h3 class="text-white ">Express</h3>
                    </div>
                    <div data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="1400">
                        <img
                            class="mx-auto my-2 bg-white rounded p-2 shadow"
                            src="https://img.icons8.com/color/96/null/nodejs.png"
                            alt="nodejs" />
                        <h3 class="text-white ">Node Js</h3>
                    </div>
                    <div data-aos="zoom-out" data-aos-duration="1500" data-aos-delay="1600">
                        <img
                            class="mx-auto my-2 bg-white rounded p-2 shadow"
                            src="https://img.icons8.com/color/96/null/postgreesql.png"
                            alt="postgresql" />
                        <h3 class="text-white ">Postgresql</h3>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Skill;
